import styled from 'styled-components'

const Style = {
	GuideDiv: styled.div`
		display: flex;
		flex-direction: column;
		gap: 4px;
		background-color: ${({theme}) => theme.color.grey1};
		border: 1px solid ${({theme}) => theme.color.grey2};
		padding: 8px 12px;
		border-radius: 4px;

		& + & {
			margin-top: 8px;

			@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
				margin-top: 10px;
			}
		}

		& > p {
			${({theme}) => theme.font.extra_small};
			color: ${({theme}) => theme.color.grey4};
		}

		& > ul {
			${({theme}) => theme.font.extra_small};
			color: ${({theme}) => theme.color.grey4};
			padding-left: 24px;
			margin: 0;
			display: flex;
			flex-direction: column;
			gap: 4px;

			& > li {
				${({theme}) => theme.font.extra_small};
				color: ${({theme}) => theme.color.grey4};
			}
		}
	`,
}

export default Style
